"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaFormulaire = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utilitaires = require("../../utils/utilitaires");

var _utilitaires2 = require("../../utils/utilitaires.requete");

var _MfaFormulairePage = require("./MfaFormulairePage");

var _MfaFormulairePagination = require("./MfaFormulairePagination");

var _MfaContexte = require("../MfaContexte");

var _semanticUiReact = require("semantic-ui-react");

var _MfaBouton = require("../MfaBouton");

var _MfaSeparateur = require("../MfaSeparateur");

var _utilitaires3 = require("../../utils/utilitaires.date");

var _MfaTypeChamp = require("../../commun/MfaTypeChamp");

require("../../css/mfa-formulaire.css");

var _utilitaires4 = require("../../utils/utilitaires.elements");

var _MfaDialogue = require("../MfaDialogue");

var _jquery = require("jquery");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaFormulaire = /*#__PURE__*/function (_Component) {
  _inherits(MfaFormulaire, _Component);

  var _super = _createSuper(MfaFormulaire);

  function MfaFormulaire(props) {
    var _this;

    _classCallCheck(this, MfaFormulaire);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "messageObligatoire", 'Ce champ est obligatoire');

    _defineProperty(_assertThisInitialized(_this), "enregistrerPositionRelativeNaivgationCommentaireBind", void 0);

    _defineProperty(_assertThisInitialized(_this), "statutCommentaire", {
      Brouillon: 0,
      Envoye: 1,
      PretCorrection: 2,
      Corrige: 3
    });

    _defineProperty(_assertThisInitialized(_this), "elementDeroulant", void 0);

    _defineProperty(_assertThisInitialized(_this), "positionRelativeNavigationCommentaire", 0);

    _defineProperty(_assertThisInitialized(_this), "typeRangee", [_MfaTypeChamp.MfaTypeChamp.case]);

    _defineProperty(_assertThisInitialized(_this), "champsErrones", {});

    _defineProperty(_assertThisInitialized(_this), "derniereValeurEnvoyee", void 0);

    _defineProperty(_assertThisInitialized(_this), "enSoumission", false);

    _defineProperty(_assertThisInitialized(_this), "soumissionEnAttente", []);

    _defineProperty(_assertThisInitialized(_this), "formulaire", void 0);

    _defineProperty(_assertThisInitialized(_this), "entete", void 0);

    _defineProperty(_assertThisInitialized(_this), "pages", {});

    _this.state = {
      formulaire: null,
      enChargement: true,
      nomChampNavigationCommentaire: (0, _utilitaires.guid)(),
      pageCourante: _this.obtenirPage(),
      valeurs: _this.obtenirValeursInitiales(),
      lectureSeuleNavigationCommentaire: false,
      nomCommentaireCible: (0, _utilitaires.estDefini)(props.nomCommentaireCible) ? props.nomCommentaireCible : null
    };
    _this.enregistrerPositionRelativeNaivgationCommentaireBind = _this.enregistrerPositionRelativeNaivgationCommentaire.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MfaFormulaire, [{
    key: "estEnChargment",
    value: function estEnChargment() {
      var propEnChargement = this.props.enChargement;
      var enChargement = this.state.enChargement;

      if (propEnChargement === true) {
        return true;
      }

      return enChargement !== false;
    }
  }, {
    key: "doitAfficherNavigationCommentaire",
    value: function doitAfficherNavigationCommentaire() {
      var doitAfficherNavigationCommentaire = this.props.doitAfficherNavigationCommentaire;

      if (doitAfficherNavigationCommentaire === false) {
        return false;
      }

      return this.obtenirCommentairesCorrigeable().length > 0;
    }
  }, {
    key: "aCommentaireCorrigeSansStatut",
    value: function aCommentaireCorrigeSansStatut(statutExclut) {
      return this.aCommentaireEtatCorrection(null, statutExclut, true);
    }
  }, {
    key: "aCommentaireNonCorrige",
    value: function aCommentaireNonCorrige(commentaires, statutExclut) {
      return this.aCommentaireEtatCorrection(commentaires, statutExclut, false);
    }
  }, {
    key: "aCommentaireEtatCorrection",
    value: function aCommentaireEtatCorrection(commentaires, statutExclut, etatCorrection) {
      return (commentaires !== null && commentaires !== void 0 ? commentaires : this.obtenirCommentairesCorrigeable()).some(function (commentaire) {
        return commentaire.estCorrige === etatCorrection && (!(0, _utilitaires.estDefini)(statutExclut) || commentaire.statut !== statutExclut);
      });
    }
  }, {
    key: "obtenirNomCommentaireDirection",
    value: function obtenirNomCommentaireDirection(direction, fonctionCommentaire) {
      var commentaires = this.obtenirCommentairesCorrigeable();

      if (commentaires.length === 0) {
        return;
      }

      var _this$state = this.state,
          nomCommentaireCible = _this$state.nomCommentaireCible,
          formulaire = _this$state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire, 'champs')) {
        return;
      }

      var champs = this.obtenirChampsFormulaire(direction !== true);
      var pageCourante = this.state.formulaire.pageCourante;
      var indexChampRepair = -1;

      if (!(0, _utilitaires.estDefini)(nomCommentaireCible)) {
        var premierChamp = this.obtenirPremierChamp(pageCourante);
        indexChampRepair = (0, _utilitaires.estDefini)(premierChamp) ? champs.findIndex(function (champ) {
          return champ === premierChamp;
        }) : -1;
      }

      var fonction = function fonction(cible) {
        return function (champ) {
          return champ.nom === cible;
        };
      };

      var indexNom = (0, _utilitaires.estDefini)(nomCommentaireCible) ? champs.findIndex(fonction(nomCommentaireCible)) : -1;
      commentaires.sort(function (a, b) {
        var indexA = champs.findIndex(fonction(a.nomChamp));
        var indexB = champs.findIndex(fonction(b.nomChamp));
        return indexA > indexB ? 1 : indexA < indexB ? -1 : 0;
      });

      var fonctionCommentaireEffective = function fonctionCommentaireEffective(commentaire) {
        return (0, _utilitaires.estDefini)(fonctionCommentaire) ? fonctionCommentaire(commentaire) : true;
      };

      var commentaireCible = commentaires.find(function (commentaire) {
        var index = champs.findIndex(fonction(commentaire.nomChamp));
        return index > indexNom && (direction ? index >= indexChampRepair : index > indexChampRepair) && fonctionCommentaireEffective(commentaire);
      });
      var commentaire = (0, _utilitaires.estDefini)(commentaireCible) ? commentaireCible : commentaires.find(fonctionCommentaireEffective);
      return (0, _utilitaires.estDefini)(commentaire) ? commentaire.nomChamp : null;
    }
  }, {
    key: "surActionNavigationCommentaire",
    value: function surActionNavigationCommentaire(direction) {
      var nom = this.obtenirNomCommentaireDirection(direction);
      this.mettreAJourNavigationCommentaire(nom);
    }
  }, {
    key: "mettreAJourNavigationCommentaire",
    value: function mettreAJourNavigationCommentaire(nomCommentaireCible, obtenirElement, callback) {
      var _this2 = this;

      var page = this.obtenirPagePourChamp(nomCommentaireCible);
      var pageCourante = this.state.pageCourante;
      this.gererEvennementDeroulement(true);
      this.setState({
        nomCommentaireCible: nomCommentaireCible,
        pageCourante: (0, _utilitaires.estDefini)(page) ? page : pageCourante
      }, function () {
        return _this2.ajusterPositionDeroulement(function () {
          _this2.gererEvennementDeroulement();

          if (!(0, _utilitaires.estDefini)(callback)) {
            return;
          }

          callback();
        }, obtenirElement);
      });
    }
  }, {
    key: "surNavigationCommentaireSuviant",
    value: function surNavigationCommentaireSuviant() {
      this.surActionNavigationCommentaire(true);
    }
  }, {
    key: "surNavigationCommentairePrecedent",
    value: function surNavigationCommentairePrecedent() {
      this.surActionNavigationCommentaire();
    }
  }, {
    key: "obtenirPagePourChamp",
    value: function obtenirPagePourChamp(nomChamp) {
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire, 'sections', 'pages')) {
        return null;
      }

      var sections = formulaire.sections,
          pages = formulaire.pages;
      var section = sections.find(function (section) {
        return (0, _utilitaires.estDefini)(section, 'champs') && section.champs.some(function (champ) {
          return champ.nom === nomChamp;
        });
      });

      if (!(0, _utilitaires.estDefini)(section, 'idPage')) {
        return null;
      }

      var page = pages.find(function (page) {
        return page.id === section.idPage;
      });
      return (0, _utilitaires.estDefini)(page) ? page : null;
    }
  }, {
    key: "obtenirObjetCommentaire",
    value: function obtenirObjetCommentaire(fonctionCondition, defaut) {
      var fonction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'filter';
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire, 'commentaires')) {
        return defaut;
      }

      return formulaire.commentaires[fonction](function (commentaire) {
        return (0, _utilitaires.estDefini)(commentaire) && fonctionCondition(commentaire);
      });
    }
  }, {
    key: "obtenirCommentaireParNom",
    value: function obtenirCommentaireParNom(nomCommentaire) {
      return this.obtenirObjetCommentaire(function (commentaire) {
        return commentaire.nomChamp === nomCommentaire;
      }, null, 'find');
    }
  }, {
    key: "obtenirCommentairesCorrigeable",
    value: function obtenirCommentairesCorrigeable() {
      return this.obtenirObjetCommentaire(function (commentaire) {
        return commentaire.estCorrigeable === true;
      }, []);
    }
  }, {
    key: "obtenirModificationsParType",
    value: function obtenirModificationsParType() {
      return this.obtenirObjetStatique('modifcationsParType', {
        'appliquerModifcationDate': _MfaTypeChamp.MfaTypeChamp.date
      });
    }
  }, {
    key: "obtenirInitialisationsParType",
    value: function obtenirInitialisationsParType() {
      return this.obtenirObjetStatique('initialisationsParType', {
        'initialiserListe': _MfaTypeChamp.MfaTypeChamp.liste
      });
    }
  }, {
    key: "obtenirObjetStatique",
    value: function obtenirObjetStatique(nom, dictionnaireFonctionType) {
      var _this3 = this;

      if (!(0, _utilitaires.estDefini)(MfaFormulaire[nom])) {
        var objet = MfaFormulaire[nom] = {};
        Object.keys(dictionnaireFonctionType).forEach(function (nomFonction) {
          var type = dictionnaireFonctionType[nomFonction];
          objet[type] = _this3[nomFonction].bind(_this3);
        });
      }

      return MfaFormulaire[nom];
    }
  }, {
    key: "obtenirValeursInitiales",
    value: function obtenirValeursInitiales() {
      var valeurs = this.props.valeurs;
      var valeursInitiales = {};

      if ((0, _utilitaires.estDefini)(valeurs)) {
        Object.assign(valeursInitiales, valeurs);
      }

      return valeursInitiales;
    }
  }, {
    key: "obtenirNombrePage",
    value: function obtenirNombrePage() {
      var pages = this.obtenirPagesFormulaire();

      if (!(0, _utilitaires.estDefini)(pages)) {
        return 0;
      }

      return (0, _utilitaires.estDefini)(pages.length) ? pages.length : 0;
    }
  }, {
    key: "obtenirPagesFormulaire",
    value: function obtenirPagesFormulaire(desc) {
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        return null;
      }

      var pages = formulaire.pages;
      1;
      pages.sort(this.obtenirFonctionTri(desc !== true ? 1 : -1));
      return pages;
    }
  }, {
    key: "obtenirFonctionTri",
    value: function obtenirFonctionTri(facteur) {
      if (!(0, _utilitaires.estDefini)(facteur)) {
        facteur = 1;
      }

      return function (a, b) {
        return a.index > b.index ? facteur : a.index < b.index ? -facteur : 0;
      };
    }
  }, {
    key: "obtenirSections",
    value: function obtenirSections(desc, formulaire) {
      if (!(0, _utilitaires.estDefini)(formulaire)) {
        formulaire = this.state.formulaire;
      }

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        return null;
      }

      var _formulaire = formulaire,
          sections = _formulaire.sections,
          pages = _formulaire.pages;

      if (!(0, _utilitaires.estDefini)(sections)) {
        return null;
      }

      var dictPages = (0, _utilitaires.estDefini)(pages) ? pages.reduce(function (dict, page) {
        dict[page.id] = page;
        return dict;
      }, {}) : {};
      sections = sections.map(function (section) {
        return section;
      });
      var facteur = desc ? -1 : 1;
      var fonctionTri = this.obtenirFonctionTri(facteur);
      sections.sort(function (a, b) {
        var pageA = dictPages[a.idPage];
        var pageB = dictPages[b.idPage];

        if ((0, _utilitaires.estDefini)(pageA)) {
          if ((0, _utilitaires.estDefini)(pageB)) {
            var resulatPage = fonctionTri(pageA, pageB);

            if (resulatPage !== 0) {
              return resulatPage;
            }
          } else {
            return 1;
          }
        } else if ((0, _utilitaires.estDefini)(pageB)) {
          return -1;
        }

        return fonctionTri(a, b);
      });
      sections.filter(function (section) {
        return (0, _utilitaires.estDefini)(section.champs);
      }).forEach(function (section) {
        section.champs = section.champs.map(function (champ) {
          return champ;
        });
        section.champs.sort(fonctionTri);
      });
      return sections;
    }
  }, {
    key: "obtenirChampsFormulaire",
    value: function obtenirChampsFormulaire(desc, formulaire) {
      var sections = this.obtenirSections(desc, formulaire);
      return (0, _utilitaires.estDefini)(sections) ? sections.prendrePlusieurs(function (section) {
        return section.champs;
      }) : null;
    }
  }, {
    key: "obtenirPage",
    value: function obtenirPage() {
      var pageCourante = (0, _utilitaires.estDefini)(this.state) ? this.state.pageCourante : null;

      if ((0, _utilitaires.estDefini)(pageCourante)) {
        return pageCourante;
      }

      return null;
    }
  }, {
    key: "obtenirIndexPageCourante",
    value: function obtenirIndexPageCourante() {
      var pages = this.obtenirPagesFormulaire();

      if (!(0, _utilitaires.estDefini)(pages)) {
        return null;
      }

      pages.sort(function (a, b) {
        return a.index > b.index ? 1 : a.index < b.index ? -1 : 0;
      });
      var pageCourante = this.state.pageCourante;
      var index = pages.findIndex(function (page) {
        return page === pageCourante;
      });

      if (isNaN(Number(index))) {
        return 0;
      }

      return index;
    }
  }, {
    key: "obtenirDictionaireCommentaires",
    value: function obtenirDictionaireCommentaires(formulaire) {
      return this.obtenirDictionaireBase(formulaire, 'commentaires', 'nomChamp');
    }
  }, {
    key: "obtenirDictionaireChamps",
    value: function obtenirDictionaireChamps(formulaire) {
      return this.obtenirDictionaireBase(formulaire, 'champs', 'nom');
    }
  }, {
    key: "obtenirDictionaireBase",
    value: function obtenirDictionaireBase(formulaire, nomProprieteFormulaire, nomProprieteCle) {
      formulaire = (0, _utilitaires.estDefini)(formulaire) ? formulaire : this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        return null;
      }

      var rangee = formulaire[nomProprieteFormulaire];

      if (!(0, _utilitaires.estDefini)(rangee)) {
        return null;
      }

      return rangee.reduce(function (dictionnaire, objet) {
        dictionnaire[objet[nomProprieteCle]] = objet;
        return dictionnaire;
      }, {});
    }
  }, {
    key: "obtenirValeursConvertiesAChaines",
    value: function obtenirValeursConvertiesAChaines() {
      var valeurs = this.state.valeurs;
      return Object.keys(valeurs).reduce(function (conversion, nomChamp) {
        var valeur = valeurs[nomChamp];

        if (valeur instanceof Array) {
          valeur = valeur.join(';#');
        } else if (valeur instanceof Date) {
          valeur = (0, _utilitaires3.formatterDateSql)(valeur);
        }

        conversion[nomChamp] = (0, _utilitaires.estDefini)(valeur) ? valeur.toString() : null;
        return conversion;
      }, {});
    }
  }, {
    key: "champEstConsidere",
    value: function champEstConsidere(champ) {
      if (!(0, _utilitaires.estDefini)(champ)) {
        return false;
      }

      var estVisible = champ.estVisible,
          lectureSeule = champ.lectureSeule;
      return estVisible !== false && lectureSeule !== true;
    }
  }, {
    key: "compilerReponsesPourEnvoie",
    value: function compilerReponsesPourEnvoie(seulementCommentaires, sansCommentaires) {
      var valeurs = this.obtenirValeursConvertiesAChaines();
      var _this$props = this.props,
          idLien = _this$props.idLien,
          codeApp = _this$props.codeApp;
      var derniereValeurEnvoyee = this.derniereValeurEnvoyee,
          champsErrones = this.champsErrones;
      var cles = Object.keys(valeurs);
      var nombreCles = cles.length;

      if (nombreCles === 0 || (0, _utilitaires.estDefini)(derniereValeurEnvoyee) && cles.every(function (cle) {
        return derniereValeurEnvoyee[cle] === valeurs[cle];
      }) && Object.keys(derniereValeurEnvoyee).length === nombreCles) {
        return [null, null];
      }

      var dictionnaireChamp = this.obtenirDictionaireChamps();
      return [Object.keys(valeurs).reduce(function (liste, nomChamp) {
        var valeur = valeurs[nomChamp];
        var valeurPrecedente = (0, _utilitaires.estDefini)(derniereValeurEnvoyee) ? derniereValeurEnvoyee[nomChamp] : null;
        var champ = dictionnaireChamp[nomChamp];

        var _ref = (0, _utilitaires.estDefini)(champ) ? champ : {},
            nom = _ref.nom,
            type = _ref.type;

        if (valeur === valeurPrecedente || Object.keys(champsErrones).includes(nom) || seulementCommentaires === true && type !== _MfaTypeChamp.MfaTypeChamp.commentaire || sansCommentaires === true && type === _MfaTypeChamp.MfaTypeChamp.commentaire) {
          return liste;
        }

        liste.push({
          codeApp: codeApp,
          nomChamp: nomChamp,
          valeur: valeurs[nomChamp],
          idLien: idLien,
          id: (0, _utilitaires.estDefini)(champ) ? champ.idReponse : null
        });
        return liste;
      }, []), valeurs];
    }
  }, {
    key: "gererEvennementDeroulement",
    value: function gererEvennementDeroulement(detacher) {
      this.elementDeroulant = detacher ? this.elementDeroulant : this.obtenirElementDeroulant();
      var elementDeroulant = this.elementDeroulant;

      if (!(0, _utilitaires.estDefini)(elementDeroulant)) {
        return;
      }

      elementDeroulant["".concat(detacher ? 'remove' : 'add', "EventListener")]('scroll', this.enregistrerPositionRelativeNaivgationCommentaireBind);
    }
  }, {
    key: "obtenirElementDeroulant",
    value: function obtenirElementDeroulant() {
      var element = (0, _utilitaires4.obtenirElementDeroulant)(this.formulaire);

      if (!(0, _utilitaires.estDefini)(element) || element === document.documentElement) {
        return document;
      }

      return element;
    }
  }, {
    key: "ajusterPositionDeroulement",
    value: function ajusterPositionDeroulement(callback, obtenirElementNavigation) {
      var _this4 = this;

      var element = this.obtenirElementDeroulant();

      if (!(0, _utilitaires.estDefini)(element)) {
        return;
      }

      if ((0, _utilitaires.estDefini)(element.documentElement)) {
        element = element.documentElement;
      }

      var champNavigation = this.obtenirChampNavigationCommentaire();
      var elementCible = (0, _utilitaires.estDefini)(obtenirElementNavigation) ? obtenirElementNavigation() : (0, _utilitaires.estDefini)(champNavigation) ? champNavigation.element : null;

      if (!(0, _utilitaires.estDefini)(elementCible)) {
        return;
      }

      window.requestAnimationFrame(function () {
        element.scrollTop = (0, _utilitaires4.top)(elementCible) - (0, _utilitaires4.top)(element) - _this4.positionRelativeNavigationCommentaire;

        if ((0, _utilitaires.estDefini)(callback)) {
          callback();
        }
      });
    }
  }, {
    key: "enregistrerPositionRelativeNaivgationCommentaire",
    value: function enregistrerPositionRelativeNaivgationCommentaire(evennement) {
      if (!(0, _utilitaires.estDefini)(evennement, 'currentTarget')) {
        return;
      }

      this.enregistrerPositionRelativeNaivgationCommentaireParElement(evennement.currentTarget);
    }
  }, {
    key: "enregistrerPositionRelativeNaivgationCommentaireParElement",
    value: function enregistrerPositionRelativeNaivgationCommentaireParElement(element, elementNavigation) {
      if (!(0, _utilitaires.estDefini)(element)) {
        return;
      } else if ((0, _utilitaires.estDefini)(element.documentElement)) {
        element = element.documentElement;
      }

      var topElementNavigation = (0, _utilitaires.estDefini)(elementNavigation) ? (0, _utilitaires4.top)(elementNavigation) : this.obtenirTopElementNavigationCommentaire();

      if (!(0, _utilitaires.estDefini)(topElementNavigation)) {
        return;
      }

      var _element = element,
          scrollTop = _element.scrollTop;
      this.positionRelativeNavigationCommentaire = topElementNavigation - (0, _utilitaires4.top)(element) - scrollTop;
    }
  }, {
    key: "obtenirTopElementNavigationCommentaire",
    value: function obtenirTopElementNavigationCommentaire() {
      var champNavigation = this.obtenirChampNavigationCommentaire();

      if (!(0, _utilitaires.estDefini)(champNavigation, 'element')) {
        return null;
      }

      return (0, _utilitaires4.top)(champNavigation.element);
    }
  }, {
    key: "obtenirChampNavigationCommentaire",
    value: function obtenirChampNavigationCommentaire() {
      var _this$state2 = this.state,
          nomChampNavigationCommentaire = _this$state2.nomChampNavigationCommentaire,
          pageCourante = _this$state2.pageCourante;
      return this.obtenirObjetChampParNom(nomChampNavigationCommentaire, pageCourante);
    }
  }, {
    key: "obtenirObjetChampParNom",
    value: function obtenirObjetChampParNom(nom, page) {
      var pages = this.pages;
      var sections = Object.keys(pages).filter(function (idPage) {
        return !(0, _utilitaires.estDefini)(page) || Number(idPage) === page.id;
      }).reduce(function (objSections, idPage) {
        var sectionsPage = pages[idPage].sections;

        if ((0, _utilitaires.estDefini)(sectionsPage)) {
          Object.assign(objSections, sectionsPage);
        }

        return objSections;
      }, {});
      var champ = Object.keys(sections).filter(function (id) {
        return (0, _utilitaires.estDefini)(sections[id], 'champs');
      }).prendrePlusieurs(function (id) {
        return (0, _utilitaires.obtenirValeurs)(sections[id].champs);
      }).find(function (cham) {
        return (0, _utilitaires.estDefini)(cham, 'props') && cham.props.nom === nom;
      });
      return (0, _utilitaires.estDefini)(champ) ? champ : null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.chargerFormulaire();
      this.gererEvennementDeroulement();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.gererEvennementDeroulement(true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nouvelleProps, nouveauEtat, nouveauContexte) {
      var _this5 = this;

      var lectureSeule = nouvelleProps.lectureSeule,
          idLien = nouvelleProps.idLien;
      var doitForcerMAJ = false;
      var nouvelIdLien = null;

      if (this.props.lectureSeule !== lectureSeule) {
        this.appliquerLectureSeule(this.obtenirChampsFormulaire(), lectureSeule);
        doitForcerMAJ = true;
      }

      if (this.props.idLien !== idLien) {
        nouvelIdLien = idLien;
      }

      var aNouvelId = (0, _utilitaires.estDefini)(nouvelIdLien);

      if (doitForcerMAJ) {
        this.forceUpdate(function () {
          if (aNouvelId) {
            _this5.chargerFormulaire(nouvelIdLien);
          }
        });
      } else if (aNouvelId) {
        this.chargerFormulaire(nouvelIdLien);
      }
    }
  }, {
    key: "chargerFormulaire",
    value: function () {
      var _chargerFormulaire = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(idLien) {
        var _this6 = this;

        var generateurAdresseFormulaire, adresseFormulaire, formulaireRequete, formulaire, pages, champs, valeurs;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                generateurAdresseFormulaire = this.props.generateurAdresseFormulaire;

                if (!(0, _utilitaires.estDefini)(idLien)) {
                  idLien = this.props.idLien;
                }

                if ((0, _utilitaires.estDefini)(idLien)) {
                  _context.next = 5;
                  break;
                }

                this.setState({
                  valeurs: {},
                  formulaire: null,
                  pageCourante: null,
                  enChargement: true
                });
                return _context.abrupt("return");

              case 5:
                if ((0, _utilitaires.estDefini)(generateurAdresseFormulaire)) {
                  _context.next = 8;
                  break;
                }

                throw "Aucun générateur d'adresse spécifié pour le formulaire";

              case 8:
                adresseFormulaire = generateurAdresseFormulaire(idLien);
                _context.next = 11;
                return (0, _utilitaires2.requete)(adresseFormulaire, this.context);

              case 11:
                formulaireRequete = _context.sent;

                if (!(0, _utilitaires2.afficherDialogueAuthentication)(formulaireRequete, this.context)) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return");

              case 14:
                _context.next = 16;
                return formulaireRequete.json();

              case 16:
                formulaire = _context.sent;
                this.appliquerChangementsSurChamps(formulaire);
                pages = formulaire.pages;
                champs = this.obtenirChampsFormulaire(false, formulaire);
                this.passerValeursParentsALEtat();
                valeurs = this.state.valeurs;
                this.mettreValeursInitiales(champs, valeurs);
                champs.forEach(function (champ) {
                  return _this6.executerEvennement(champ, valeurs, champs, function (nomChamp, expression, fonction, retrait, champsAssocies, estAsync) {
                    return _this6.gererValidationPersonaliseeInterne(nomChamp, expression, fonction, retrait, champsAssocies, estAsync, champs);
                  }, champ.valeurInitiale);
                });
                this.setState({
                  valeurs: valeurs,
                  formulaire: formulaire,
                  pageCourante: (0, _utilitaires.estDefini)(pages) && (0, _utilitaires.estDefini)(pages[0]) ? pages[0] : null,
                  enChargement: false,
                  nomCommentaireCible: this.obtenirNomCommentaireCibleInitial(formulaire)
                }, function () {
                  if (Object.keys(valeurs).length > 0) {
                    _this6.soumission();
                  }

                  window.requestAnimationFrame(function () {
                    _this6.enregistrerPositionRelativeNaivgationCommentaireParElement(_this6.obtenirElementDeroulant());

                    var surChargementFormulaire = _this6.props.surChargementFormulaire;

                    if ((0, _utilitaires.estDefini)(surChargementFormulaire)) {
                      surChargementFormulaire(formulaire);
                    }
                  });
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function chargerFormulaire(_x) {
        return _chargerFormulaire.apply(this, arguments);
      }

      return chargerFormulaire;
    }()
  }, {
    key: "obtenirNomCommentaireCibleInitial",
    value: function obtenirNomCommentaireCibleInitial(formulaire) {
      if (!this.doitAfficherNavigationCommentaire() || !(0, _utilitaires.estDefini)(formulaire, ['pages', 0])) {
        return null;
      }

      var pages = formulaire.pages;
      return this.obtenirNomPremierChampSiCommentaire(pages[0], formulaire);
    }
  }, {
    key: "obtenirPremierChamp",
    value: function obtenirPremierChamp(page, formulaire) {
      var sections = this.obtenirSectionsCourantes(page, formulaire, true);

      if ((0, _utilitaires.estDefini)(sections, [0, ['champs', 0]])) {
        return sections[0].champs[0];
      }

      return null;
    }
  }, {
    key: "obtenirNomPremierChampSiCommentaire",
    value: function obtenirNomPremierChampSiCommentaire(page, formulaire) {
      var champ = this.obtenirPremierChamp(page, formulaire);

      if ((0, _utilitaires.estDefini)(champ) && champ.type === _MfaTypeChamp.MfaTypeChamp.commentaire && champ.estCorrigeable === true) {
        return champ.nom;
      }

      return null;
    }
  }, {
    key: "passerValeursParentsALEtat",
    value: function passerValeursParentsALEtat() {
      var valeurs = this.state.valeurs;
      var valeursProps = this.props.valeurs;

      if ((0, _utilitaires.estDefini)(valeursProps)) {
        Object.assign(valeurs, valeursProps);
      }
    }
  }, {
    key: "mettreValeursInitiales",
    value: function mettreValeursInitiales(champs, valeurs) {
      if (!(0, _utilitaires.estDefini)(champs)) {
        return;
      }

      var valeursForcees = this.props.valeurs;
      var initialisationsParType = this.obtenirInitialisationsParType();
      champs.forEach(function (champ) {
        var aValeur = (0, _utilitaires.estDefini)(valeursForcees) && (0, _utilitaires.estDefini)(valeursForcees[nom]);

        if (aValeur) {
          return;
        }

        var valeurInitiale = champ.valeurInitiale,
            nom = champ.nom,
            type = champ.type;
        var initialiseur = initialisationsParType[type];

        if (!(0, _utilitaires.estDefini)(valeurInitiale)) {
          if ((0, _utilitaires.estDefini)(initialiseur)) {
            initialiseur(champ, valeurs);
          }

          return;
        }

        valeurs[nom] = valeurInitiale;
      });
    }
  }, {
    key: "mettreValeursEtat",
    value: function mettreValeursEtat(champs) {
      var _this$obtenirDictiona,
          _this7 = this;

      if (!(0, _utilitaires.estDefini)(champs)) {
        return;
      }

      var valeurs = this.state.valeurs;
      var nomsCommentaires = Object.keys((_this$obtenirDictiona = this.obtenirDictionaireCommentaires()) !== null && _this$obtenirDictiona !== void 0 ? _this$obtenirDictiona : {});
      champs.forEach(function (champ) {
        var valeur = valeurs[champ.nom];

        if (!(0, _utilitaires.estDefini)(valeur)) {
          return;
        }

        var estCommentaire = nomsCommentaires.indexOf(champ.nom) != -1;
        champ[estCommentaire ? 'valeur' : 'valeurInitiale'] = valeur;

        if (estCommentaire) {
          champ.etendre = (0, _utilitaires.nestPasNulOuVide)(valeur);
        }

        if (_this7.estTypeRangee(champ)) {
          _this7.convertirValeurProprieteRangee(champ, 'valeurInitiale');
        }
      });
    }
  }, {
    key: "annulation",
    value: function annulation() {
      var _this$props2 = this.props,
          surSortie = _this$props2.surSortie,
          confirmerAnnulation = _this$props2.confirmerAnnulation;

      if (!(0, _utilitaires.estDefini)(surSortie)) {
        return;
      }

      if (confirmerAnnulation === true) {
        this.setState({
          afficherDialogueConfirmer: true
        });
        return;
      }

      surSortie();
    }
  }, {
    key: "actionFin",
    value: function actionFin() {
      var surActionFin = this.props.surActionFin;

      if (!(0, _utilitaires.estDefini)(surActionFin)) {
        return;
      }

      surActionFin();
    }
  }, {
    key: "terminaison",
    value: function terminaison() {
      var pageCourante = this.state.pageCourante;
      var champsManquants = this.obtenirChampCourantsObligatoireVides();
      var champsCourantErrones = this.obtenirChampsErronesCourants();

      if (champsCourantErrones.length > 0) {
        this.deroulerVersChamp(champsCourantErrones[0]);
        return;
      } else if ((0, _utilitaires.estDefini)(champsManquants) && champsManquants.length > 0) {
        this.appliquerMessageErreur(champsManquants, this.messageObligatoire);
        this.deroulerVersChamp(champsManquants[0].nom);
        return;
      }

      var nomCommentaireCible = this.obtenirNomPremierChampSiCommentaire(pageCourante.index - 1);

      if ((0, _utilitaires.estDefini)(nomCommentaireCible)) {
        return;
      }

      var surTerminaison = this.props.surTerminaison;

      if (!(0, _utilitaires.estDefini)(surTerminaison)) {
        return;
      }

      surTerminaison();
    }
  }, {
    key: "capturerValeur",
    value: function capturerValeur(champ, valeur, callback) {
      var nom = champ.nom;
      var valeurs = this.state.valeurs;
      valeurs[nom] = valeur;
      console.log(valeurs);
      var doitMettreAJour = this.verifierMiseAJour(champ, valeur);

      var effectuerCallback = function effectuerCallback() {
        if ((0, _utilitaires.estDefini)(callback)) {
          try {
            callback();
          } catch (ex) {
            console.error(ex);
          }
        }
      };

      if (doitMettreAJour) {
        this.forceUpdate(effectuerCallback);
      } else {
        effectuerCallback();
      }
    }
  }, {
    key: "obtenirLectureSeule",
    value: function obtenirLectureSeule(formulaire) {
      var lectureSeule = this.props.lectureSeule;

      if ((0, _utilitaires.estDefini)(lectureSeule)) {
        return lectureSeule;
      }

      var lectureSeuleFormulaire = (0, _utilitaires.estDefini)(formulaire) ? formulaire.lectureSeule : null;
      return (0, _utilitaires.estDefini)(lectureSeuleFormulaire) ? lectureSeuleFormulaire : false;
    }
  }, {
    key: "appliquerChangementsSurChamps",
    value: function appliquerChangementsSurChamps(formulaire) {
      var _this8 = this;

      var lectureSeule = this.obtenirLectureSeule(formulaire);
      var sections;

      if (!(0, _utilitaires.estDefini)(formulaire) || !(0, _utilitaires.estDefini)(sections = formulaire.sections)) {
        return;
      }

      var dictionnaireCommentaires = this.obtenirDictionaireCommentaires(formulaire);
      sections.forEach(function (section) {
        var champs = section.champs;

        if (!champs || !champs.length) {
          return;
        }

        champs.forEach(function (champ) {
          return _this8.appliquerChangementsSurChamp(champ, dictionnaireCommentaires);
        });

        if (!(0, _utilitaires.estDefini)(lectureSeule) || !lectureSeule) {
          return;
        }

        _this8.appliquerLectureSeule(champs, lectureSeule);
      });
    }
  }, {
    key: "appliquerChangementsSurChamp",
    value: function appliquerChangementsSurChamp(champ, dictionnaireCommentaires) {
      champ.id = champ.nom;
      this.appliquerValeurDuParent(champ);
      this.appliquerProprietesDuParent(champ);
      this.convertirValeurRangee(champ);
      this.appliquerEvennementSurChangement(champ);
      this.appliquerEvennementSurValidation(champ);
      this.appliquerEvennementSurPerteDeFocus(champ);

      if (champ.type !== _MfaTypeChamp.MfaTypeChamp.commentaire || !(0, _utilitaires.estDefini)(dictionnaireCommentaires)) {
        return;
      }

      this.appliquerChangementsSurChampCommentaire(champ, dictionnaireCommentaires[champ.nom]);
    }
  }, {
    key: "appliquerChangementsSurChampCommentaire",
    value: function appliquerChangementsSurChampCommentaire(champ, commentaire) {
      var _this9 = this;

      if (!(0, _utilitaires.estDefini)(commentaire)) {
        champ.estVisible = this.props.commentaireVisibleParDefaut;
      } else {
        var props = ['texte', 'correction', 'estCorrige', 'estCorrigeable', 'desactive', 'afficherRetablirCommentaires', 'afficherSupprimerCommentaires'];
        var dictionnaireProps = {
          texte: 'valeur'
        };
        props.forEach(function (prop) {
          var _dictionnaireProps$pr;

          var valeur = commentaire[prop];

          if (!(0, _utilitaires.estDefini)(valeur)) {
            return;
          }

          var propEffective = (_dictionnaireProps$pr = dictionnaireProps[prop]) !== null && _dictionnaireProps$pr !== void 0 ? _dictionnaireProps$pr : prop;
          champ[propEffective] = commentaire[prop];
        });

        if ((0, _utilitaires.nestPasNulOuVide)(commentaire.texte) && commentaire.correction !== true) {
          champ.etendre = true;
        }
      }

      if (champ.desactive === true && champ.estCorrigeable === true) {
        champ.texteCorrection = 'En attente de révision';
      }

      if (this.props.lectureSeuleCommentaire === true) {
        champ.desactive = true;
      }

      champ.afficherRetablirCommentaires = (0, _utilitaires.estDefini)(this.props.afficherRetablirCommentaires) ? this.props.afficherRetablirCommentaires : true;
      champ.afficherSupprimerCommentaires = (0, _utilitaires.estDefini)(this.props.afficherSupprimerCommentaires) ? this.props.afficherSupprimerCommentaires : true;
      var _this$props3 = this.props,
          generateurAdresseCorrectionCommentaire = _this$props3.generateurAdresseCorrectionCommentaire,
          adresseSuppressionCommentaire = _this$props3.adresseSuppressionCommentaire,
          adresseRetablirCommentaire = _this$props3.adresseRetablirCommentaire;

      if ((0, _utilitaires.estDefini)(generateurAdresseCorrectionCommentaire)) {
        var surCorrectionCommentaire = this.props.surCorrectionCommentaire;

        champ.surCorrection = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(corrige) {
            var commentaire, adresseCorrectionCommentaire;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    commentaire = _this9.obtenirCommentaireParNom(champ.nom);
                    adresseCorrectionCommentaire = generateurAdresseCorrectionCommentaire(commentaire);
                    champ.desactive = true;
                    champ.estCorrige = corrige;
                    _context3.next = 6;
                    return _this9.actionNavigationCommentaireLectureSeule( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return (0, _utilitaires2.requetePost)(adresseCorrectionCommentaire, _this9.context, corrige);

                            case 2:
                              _this9.mettreAJourCommentaireCorrigeable(champ, corrige);

                              champ.desactive = false;

                              if ((0, _utilitaires.estDefini)(surCorrectionCommentaire)) {
                                surCorrectionCommentaire(champ);
                              }

                            case 5:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    })));

                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }

      if ((0, _utilitaires.estDefini)(adresseSuppressionCommentaire)) {
        champ.surSupression = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var commentaire, reponse, resultat;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  commentaire = _this9.obtenirCommentaireParNom(champ.nom);

                  if ((0, _utilitaires.estDefini)(commentaire)) {
                    _context4.next = 4;
                    break;
                  }

                  _this9.reinitialiserChampCommentaire(champ);

                  return _context4.abrupt("return");

                case 4:
                  _context4.next = 6;
                  return (0, _utilitaires2.requetePost)(adresseSuppressionCommentaire, _this9.context, commentaire.id);

                case 6:
                  reponse = _context4.sent;
                  _context4.next = 9;
                  return reponse.json();

                case 9:
                  resultat = _context4.sent;

                  if (resultat === true) {
                    _this9.supprimerCommentaire(commentaire);
                  }

                case 11:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
      }

      if ((0, _utilitaires.estDefini)(adresseRetablirCommentaire)) {
        champ.surRetablissement = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          var commentaire, reponse, resultat;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  commentaire = _this9.obtenirCommentaireParNom(champ.nom);
                  _context5.next = 3;
                  return (0, _utilitaires2.requetePost)(adresseRetablirCommentaire, _this9.context, commentaire.id);

                case 3:
                  reponse = _context5.sent;
                  _context5.next = 6;
                  return reponse.json();

                case 6:
                  resultat = _context5.sent;

                  if (resultat === true) {
                    _this9.retablirCommentaires(commentaire);
                  }

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
      }

      champ.surChangementAction = function (code) {
        champ.codeInitial = code;
      };

      champ.surCliqueEnveloppe = function (element) {
        if (!(0, _utilitaires.estDefini)(element)) {
          return;
        }

        var correction = champ.correction,
            nom = champ.nom;

        if (correction !== true) {
          return;
        }

        var nomCommentaireCible = _this9.state.nomCommentaireCible;

        if (nomCommentaireCible === nom) {
          return;
        }

        _this9.enregistrerPositionRelativeNaivgationCommentaireParElement(_this9.elementDeroulant, element);

        _this9.mettreAJourNavigationCommentaire(nom, function () {
          var objetChamp = _this9.obtenirObjetChampParNom(nom);

          return (0, _utilitaires.estDefini)(objetChamp, 'element') ? objetChamp.element : null;
        }, function () {
          return _this9.enregistrerPositionRelativeNaivgationCommentaireParElement(_this9.elementDeroulant);
        });
      };
    }
  }, {
    key: "obtenirCommenaires",
    value: function obtenirCommenaires() {
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire, 'commentaires')) {
        return;
      }

      return formulaire.commentaires;
    }
  }, {
    key: "supprimerCommentaire",
    value: function supprimerCommentaire(commentaire) {
      var _this10 = this;

      this.executerSurCommentaire(commentaire, function (index, commentaires, champ) {
        if ((0, _utilitaires.estDefini)(champ)) {
          _this10.reinitialiserChampCommentaire(champ);
        }

        commentaires.splice(index, 1);
      });
    }
  }, {
    key: "reinitialiserChampCommentaire",
    value: function reinitialiserChampCommentaire(champ) {
      delete champ.valeurInitiale;
      delete champ.valeur;
      champ.etendre = false;
      champ.codeInitial = 0;
      delete this.state.valeurs[champ.nom];

      if ((0, _utilitaires.estDefini)(this.derniereValeurEnvoyee)) {
        delete this.derniereValeurEnvoyee[champ.nom];
      }
    }
  }, {
    key: "retablirCommentaires",
    value: function retablirCommentaires(commentaire) {
      commentaire.estCorrige = false;
    }
  }, {
    key: "executerSurCommentaire",
    value: function executerSurCommentaire(commentaire, callback) {
      var commentaires = this.obtenirCommenaires();

      if (!(0, _utilitaires.estDefini)(commentaires)) {
        return;
      }

      var index = commentaires.findIndex(function (comm) {
        return comm === commentaire;
      });

      if (index === -1) {
        return;
      }

      var champs = this.obtenirChampsFormulaire();
      callback(index, commentaires, (0, _utilitaires.estDefini)(champs) ? champs.find(function (champ) {
        return champ.nom === commentaire.nomChamp;
      }) : null);
    }
  }, {
    key: "mettreAJourCommentaireCorrigeable",
    value: function mettreAJourCommentaireCorrigeable(champCommentaire, corrige) {
      var commentaires = this.obtenirCommentairesCorrigeable();
      champCommentaire.estCorrige = corrige;

      if (!(0, _utilitaires.estDefini)(commentaires)) {
        return;
      }

      var commentaire = commentaires.find(function (commentaire) {
        return commentaire.nomChamp === champCommentaire.nom;
      });

      if (!(0, _utilitaires.estDefini)(commentaire)) {
        return;
      }

      if (corrige === true && commentaire.statut < this.statutCommentaire.PretCorrection) {
        commentaire.statut = this.statutCommentaire.PretCorrection;
      } else if (corrige === false) {
        commentaire.statut = this.statutCommentaire.Envoye;
      }

      commentaire.estCorrige = corrige;
    }
  }, {
    key: "estTypeRangee",
    value: function estTypeRangee(champ) {
      return (0, _utilitaires.estDefini)(champ) && this.typeRangee.indexOf(champ.type) !== -1;
    }
  }, {
    key: "convertirValeurRangee",
    value: function convertirValeurRangee(champ) {
      if (!this.estTypeRangee(champ)) {
        return;
      }

      this.convertirValeurProprieteRangee(champ, 'valeur');
      this.convertirValeurProprieteRangee(champ, 'valeurInitiale');
    }
  }, {
    key: "convertirValeurProprieteRangee",
    value: function convertirValeurProprieteRangee(champ, propriete) {
      var valeur = champ[propriete];

      if (!(0, _utilitaires.estDefini)(valeur) || valeur instanceof Array) {
        return;
      }

      champ[propriete] = valeur.toString().split(';#');
    }
  }, {
    key: "appliquerValeurDuParent",
    value: function appliquerValeurDuParent(champ) {
      this.appliquerComportementDuParent(champ, 'valeurs', function (cham, valeur) {
        return cham.valeur = valeur;
      });
    }
  }, {
    key: "appliquerProprietesDuParent",
    value: function appliquerProprietesDuParent(champ) {
      this.appliquerComportementDuParent(champ, 'proprietesChamps', function (cham, valeur) {
        return Object.assign(cham, valeur);
      });
    }
  }, {
    key: "appliquerComportementDuParent",
    value: function appliquerComportementDuParent(champ, nomProprieteDictionnaire, callback) {
      var nom = champ.nom;
      var dictionnaire = this.props[nomProprieteDictionnaire];
      var valeur = (0, _utilitaires.estDefini)(dictionnaire) ? dictionnaire[nom] : null;

      if ((0, _utilitaires.estDefini)(valeur)) {
        callback(champ, valeur);
      }
    }
  }, {
    key: "appliquerEvennementSurValidation",
    value: function appliquerEvennementSurValidation(champ) {
      var _this11 = this;

      champ.validationAsync = true;
      var surValidation = champ.surValidation,
          nom = champ.nom;

      champ.surValidation = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(valeur) {
          var champsValidationsAssocies, _yield$_this11$obteni, _yield$_this11$obteni2, messageErreur, validation, champsErrones, validationPrecedente, champsAssocies;

          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  champsValidationsAssocies = champ.champsValidationsAssocies;
                  _context6.next = 3;
                  return _this11.obtenirMessageErreur(champ, valeur);

                case 3:
                  _yield$_this11$obteni = _context6.sent;
                  _yield$_this11$obteni2 = _slicedToArray(_yield$_this11$obteni, 2);
                  messageErreur = _yield$_this11$obteni2[0];
                  validation = _yield$_this11$obteni2[1];

                  if (!(0, _utilitaires.estDefini)(messageErreur) && (0, _utilitaires.estDefini)(surValidation)) {
                    messageErreur = surValidation(valeur, nom, _this11.state.valeurs);
                  }

                  champsErrones = _this11.champsErrones;
                  validationPrecedente = (0, _utilitaires.estDefini)(champsErrones, nom) ? champsErrones[nom] : null;
                  delete champsErrones[nom];
                  champsAssocies = champsValidationsAssocies;

                  if ((0, _utilitaires.estDefini)(messageErreur)) {
                    champsAssocies = (0, _utilitaires.estDefini)(validation, 'champsAssocies') ? validation.champsAssocies : champsAssocies;
                    _this11.champsErrones[nom] = validation;
                  } else if ((0, _utilitaires.estDefini)(validationPrecedente, 'champsAssocies')) {
                    champsAssocies = validationPrecedente.champsAssocies;
                  }

                  _this11.declencherValidationsAssociees(champsAssocies);

                  return _context6.abrupt("return", messageErreur);

                case 15:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "declencherValidationsAssociees",
    value: function declencherValidationsAssociees(champsAssocies) {
      var _this12 = this;

      if (!(0, _utilitaires.estDefini)(champsAssocies)) {
        return;
      }

      if (champsAssocies.length === 0) {
        return;
      }

      champsAssocies.forEach(function (nomChamp) {
        _this12.declencherValidationParNom(nomChamp);
      });
    }
  }, {
    key: "appliquerEvennementSurPerteDeFocus",
    value: function appliquerEvennementSurPerteDeFocus(champ) {
      var _this13 = this;

      var surPerteDeFocus = champ.surPerteDeFocus;

      champ.surPerteDeFocus = function (valeur) {
        _this13.soumission(valeur, surPerteDeFocus);
      };
    }
  }, {
    key: "soumission",
    value: function () {
      var _soumission = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valeur, preCallback) {
        var enSoumission, soumissionEnAttente, _this$props4, doitSoumettre, doitSoumettreCommentaires, lectureSeule, commentairesSeulement, _this$compilerReponse, _this$compilerReponse2, reponses, valeurs, adresseEnregistrement, reponseValeurs, reponseSoumission;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                enSoumission = this.enSoumission, soumissionEnAttente = this.soumissionEnAttente;

                if (!enSoumission) {
                  _context7.next = 4;
                  break;
                }

                soumissionEnAttente.push({
                  valeur: valeur,
                  preCallback: preCallback
                });
                return _context7.abrupt("return");

              case 4:
                this.enSoumission = true;
                _this$props4 = this.props, doitSoumettre = _this$props4.doitSoumettre, doitSoumettreCommentaires = _this$props4.doitSoumettreCommentaires;
                lectureSeule = this.obtenirLectureSeule(this.state.formulaire);

                if (!(doitSoumettre === false && doitSoumettreCommentaires !== true)) {
                  _context7.next = 10;
                  break;
                }

                this.soumettreEnAttente();
                return _context7.abrupt("return");

              case 10:
                commentairesSeulement = lectureSeule === true || doitSoumettre === false;

                if ((0, _utilitaires.estDefini)(preCallback)) {
                  preCallback(valeur);
                }

                _this$compilerReponse = this.compilerReponsesPourEnvoie(commentairesSeulement, doitSoumettreCommentaires === false), _this$compilerReponse2 = _slicedToArray(_this$compilerReponse, 2), reponses = _this$compilerReponse2[0], valeurs = _this$compilerReponse2[1];

                if (!(!(0, _utilitaires.estDefini)(reponses) || reponses.length === 0)) {
                  _context7.next = 16;
                  break;
                }

                this.soumettreEnAttente();
                return _context7.abrupt("return");

              case 16:
                adresseEnregistrement = this.props.adresseEnregistrement;

                if ((0, _utilitaires.estDefini)(adresseEnregistrement)) {
                  _context7.next = 20;
                  break;
                }

                this.soumettreEnAttente();
                return _context7.abrupt("return");

              case 20:
                _context7.next = 22;
                return (0, _utilitaires2.requetePost)(adresseEnregistrement, this.context, reponses);

              case 22:
                reponseValeurs = _context7.sent;

                if (!(reponseValeurs.status === 200)) {
                  _context7.next = 34;
                  break;
                }

                this.derniereValeurEnvoyee = {};
                Object.assign(this.derniereValeurEnvoyee, valeurs);
                _context7.next = 28;
                return reponseValeurs.json();

              case 28:
                reponseSoumission = _context7.sent;
                this.assignerIdReponses(reponseSoumission);
                this.mettreAJourCommentaireApresSoumission(reponseSoumission);
                this.executerEvennementApresSoumission();
                _context7.next = 36;
                break;

              case 34:
                if (!(0, _utilitaires2.afficherDialogueAuthentication)(reponseValeurs, this.context)) {
                  _context7.next = 36;
                  break;
                }

                return _context7.abrupt("return");

              case 36:
                this.formulaire.submit();
                this.soumettreEnAttente();

              case 38:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function soumission(_x4, _x5) {
        return _soumission.apply(this, arguments);
      }

      return soumission;
    }()
  }, {
    key: "executerEvennementApresSoumission",
    value: function executerEvennementApresSoumission() {
      var surApresSoumission = this.props.surApresSoumission;

      if (!(0, _utilitaires.estDefini)(surApresSoumission)) {
        return;
      }

      surApresSoumission(this.state.valeurs);
    }
  }, {
    key: "soumettreEnAttente",
    value: function soumettreEnAttente() {
      this.enSoumission = false;
      var soumissionEnAttente = this.soumissionEnAttente;

      if (soumissionEnAttente.length === 0) {
        return;
      }

      var _soumissionEnAttente$ = soumissionEnAttente.shift(),
          valeur = _soumissionEnAttente$.valeur,
          preCallback = _soumissionEnAttente$.preCallback;

      this.soumission(valeur, preCallback);
    }
  }, {
    key: "mettreAJourCommentaireApresSoumission",
    value: function mettreAJourCommentaireApresSoumission(reponseSoumission) {
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(reponseSoumission, 'commentaires') || !(0, _utilitaires.estDefini)(formulaire)) {
        return;
      }

      var commentairesRetournes = reponseSoumission.commentaires;

      if (commentairesRetournes.length === 0) {
        return;
      }

      var commentaires = formulaire.commentaires;

      if (!(0, _utilitaires.estDefini)(commentaires)) {
        commentaires = formulaire.commentaires = [];
      }

      var ids = commentaires.map(function (commentaire) {
        return commentaire.id;
      });

      var fonction = function fonction(id) {
        return function (commentaire) {
          return commentaire.id === id;
        };
      };

      ids.forEach(function (id) {
        var commentaireRetourne = commentairesRetournes.find(fonction(id));

        if (!(0, _utilitaires.estDefini)(commentaireRetourne)) {
          return;
        }

        commentaires.splice(commentaires, commentaires.findIndex(fonction(id)), 1, commentaireRetourne);
      });
      commentairesRetournes.filter(function (commentaire) {
        return ids.indexOf(commentaire.id) == -1;
      }).forEach(function (commentaire) {
        return commentaires.push(commentaire);
      });
    }
  }, {
    key: "assignerIdReponses",
    value: function assignerIdReponses(reponseSoumission) {
      if (!(0, _utilitaires.estDefini)(reponseSoumission, 'reponses')) {
        return;
      }

      var dictionnaireChamps = this.obtenirDictionaireChamps();

      if (!(0, _utilitaires.estDefini)(dictionnaireChamps)) {
        return;
      }

      var reponses = reponseSoumission.reponses;
      reponses.forEach(function (reponse) {
        var champ = dictionnaireChamps[reponse.nomChamp];

        if (!(0, _utilitaires.estDefini)(champ)) {
          return;
        }

        champ.idReponse = reponse.id;
      });
    }
  }, {
    key: "appliquerEvennementSurChangement",
    value: function appliquerEvennementSurChangement(champ) {
      var _this14 = this;

      var surChangement = champ.surChangement;

      champ.surChangement = function (valeur) {
        var valeurPrecedente = _this14.state.valeurs[champ.nom];

        _this14.capturerValeur(champ, valeur, function () {
          if (surChangement) {
            surChangement(valeur);
          }

          _this14.executerEvennement(champ, null, null, null, valeurPrecedente);
        });
      };
    }
  }, {
    key: "executerEvennement",
    value: function executerEvennement(champ, valeurs, champs, fonctionValidation, valeurPrecedente) {
      var evennements = this.props.evennements;

      if (!(0, _utilitaires.estDefini)(valeurs)) {
        valeurs = this.state.valeurs;
      }

      if (!(0, _utilitaires.estDefini)(champs)) {
        champs = this.obtenirChampsFormulaire();
      }

      if (!(0, _utilitaires.estDefini)(evennements, champ.nom)) {
        return;
      }

      if (!(0, _utilitaires.estDefini)(fonctionValidation)) {
        fonctionValidation = this.gererValidationPersonalisee.bind(this);
      }

      if (evennements[champ.nom](valeurs, champs, champ, fonctionValidation, valeurPrecedente) !== false) {
        this.forceUpdate();
      }
    }
  }, {
    key: "appliquerMessageErreur",
    value: function appliquerMessageErreur(champs, messageErreur) {
      if (!(0, _utilitaires.estDefini)(champs)) {
        return;
      }

      champs.forEach(function (champ) {
        champ.messageErreur = messageErreur;
      });
      var formulaire = this.state.formulaire;
      this.setState({
        formulaire: formulaire
      });
    }
  }, {
    key: "appliquerLectureSeule",
    value: function appliquerLectureSeule(champs, lectureSeule) {
      var _this15 = this;

      if (!(0, _utilitaires.estDefini)(champs)) {
        return;
      }

      champs.filter(function (champ) {
        return champ.type !== _MfaTypeChamp.MfaTypeChamp.commentaire;
      }).forEach(function (champ) {
        if (!!lectureSeule) {
          if (champ.lectureSeule === true) {
            champ.valeur = champ.valeurInitiale;
          } else {
            champ.lectureSeule = true;
            champ.valeur = _this15.obtenirValeurChamp(champ.nom, champ.valeurInitiale);
          }
        } else {
          delete champ.lectureSeule;
          champ.valeurInitiale = _this15.obtenirValeurChamp(champ.nom, champ.valeurInitiale);
          delete champ.valeur;
        }
      });
    }
  }, {
    key: "appliquerModificationParType",
    value: function appliquerModificationParType(champ, valeur) {
      var modificationsParType = this.obtenirModificationsParType();
      var modificationsType = modificationsParType[champ.type];

      if (!(0, _utilitaires.estDefini)(modificationsType)) {
        return false;
      }

      return modificationsType(champ, valeur);
    }
  }, {
    key: "appliquerModifcationDate",
    value: function appliquerModifcationDate(champ, valeur) {
      if ((0, _utilitaires3.estDateValide)(valeur)) {
        champ.valeur = valeur;
        return true;
      }

      return false;
    }
  }, {
    key: "initialiserListe",
    value: function initialiserListe(champ, valeurs) {
      var nom = champ.nom,
          donnees = champ.donnees;

      if (!(0, _utilitaires.estDefini)(donnees) || donnees.length === 0) {
        return;
      }

      valeurs[nom] = donnees[0].valeur;
    }
  }, {
    key: "obtenirValeurChamp",
    value: function obtenirValeurChamp(nomChamp, valeurDefaut) {
      var valeurs = this.state.valeurs;
      var valeur = valeurs[nomChamp];
      return (0, _utilitaires.estDefini)(valeur) ? valeur : (0, _utilitaires.estDefini)(valeurDefaut) ? valeurDefaut : '';
    }
  }, {
    key: "verifierMiseAJour",
    value: function verifierMiseAJour(champ, valeur) {
      var doitMettreAJour = this.verifierValeurObligatoire(champ, valeur);
      doitMettreAJour = this.appliquerModificationParType(champ, valeur) || doitMettreAJour;
      return doitMettreAJour;
    }
  }, {
    key: "verifierValeurObligatoire",
    value: function verifierValeurObligatoire(champ, valeur) {
      if ((0, _utilitaires.estDefini)(valeur) && champ.messageErreur === this.messageObligatoire) {
        delete champ.messageErreur;
        return true;
      }

      return false;
    }
  }, {
    key: "obtenirMessageErreur",
    value: function () {
      var _obtenirMessageErreur = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(champ, valeur) {
        var retourNull, valeurs, validations, copiesValidations, validationsExpressions, validationExpression, validationFonctions, resultatsValidations, _resultatsValidations, resultat, validation, resultatAsync;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                retourNull = [null, null];
                valeurs = this.state.valeurs;

                if ((0, _utilitaires.estDefini)(valeur.match)) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return", retourNull);

              case 4:
                validations = champ.validations;

                if (!(!(0, _utilitaires.estDefini)(validations) || validations.length === 0)) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt("return", retourNull);

              case 7:
                copiesValidations = validations.map(function (val) {
                  return Object.assign({}, val);
                });
                copiesValidations.forEach(function (val) {
                  return val.expression = (0, _utilitaires.essaieObtenirRegexp)(val.expression);
                });
                validationsExpressions = copiesValidations.filter(function (val) {
                  return (0, _utilitaires.estDefini)(val.expression);
                });
                validationExpression = (0, _utilitaires.nestPasNulOuVide)(valeur) ? validationsExpressions.find(function (val) {
                  return !(0, _utilitaires.estDefini)(valeur.match(val.expression));
                }) : null;

                if (!(0, _utilitaires.estDefini)(validationExpression)) {
                  _context8.next = 13;
                  break;
                }

                return _context8.abrupt("return", [validationExpression.message, validationExpression]);

              case 13:
                validationFonctions = copiesValidations.filter(function (val) {
                  return (0, _utilitaires.estDefini)(val.fonction);
                });
                resultatsValidations = validationFonctions.map(function (validation) {
                  return {
                    resultat: validation.fonction(valeur, valeurs, champ),
                    validation: validation
                  };
                });

              case 15:
                if (!resultatsValidations.length) {
                  _context8.next = 28;
                  break;
                }

                _resultatsValidations = resultatsValidations.splice(0, 1)[0], resultat = _resultatsValidations.resultat, validation = _resultatsValidations.validation;

                if (!(validation.estAsync === false)) {
                  _context8.next = 21;
                  break;
                }

                if (!(0, _utilitaires.estDefini)(resultat)) {
                  _context8.next = 20;
                  break;
                }

                return _context8.abrupt("return", [resultat, validation]);

              case 20:
                return _context8.abrupt("continue", 15);

              case 21:
                _context8.next = 23;
                return resultat;

              case 23:
                resultatAsync = _context8.sent;

                if (!(0, _utilitaires.estDefini)(resultatAsync)) {
                  _context8.next = 26;
                  break;
                }

                return _context8.abrupt("return", [resultatAsync, validation]);

              case 26:
                _context8.next = 15;
                break;

              case 28:
                return _context8.abrupt("return", retourNull);

              case 29:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function obtenirMessageErreur(_x6, _x7) {
        return _obtenirMessageErreur.apply(this, arguments);
      }

      return obtenirMessageErreur;
    }()
  }, {
    key: "obtenirSectionsCourantes",
    value: function obtenirSectionsCourantes(pageCible, formulaire, nePasFormater) {
      var _this16 = this;

      var aPageCible = (0, _utilitaires.estDefini)(pageCible);

      if (aPageCible && !(0, _utilitaires.estDefini)(pageCible.id)) {
        return null;
      }

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        formulaire = this.state.formulaire;
      }

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        return null;
      }

      var _formulaire2 = formulaire,
          sections = _formulaire2.sections;

      if (!(0, _utilitaires.estDefini)(sections)) {
        return null;
      }

      var pageCourante = this.obtenirPage();
      var idCible = aPageCible ? pageCible.id : pageCourante.id;
      var sectionsCourantes = sections.filter(function (section) {
        return section.idPage === idCible;
      });
      sectionsCourantes.sort(function (a, b) {
        var indexA = a.index;
        var indexB = b.index;
        return indexA > indexB ? 1 : indexA < indexB ? -1 : 0;
      });
      sectionsCourantes.forEach(function (section) {
        _this16.mettreValeursEtat(section.champs);
      });
      var index0 = sectionsCourantes.length > 0 ? sectionsCourantes[0].index : null;
      return sectionsCourantes.map(function (section) {
        return nePasFormater !== true ? _this16.formaterSectionNavigationCommentaireSiLieu(section, index0) : section;
      });
    }
  }, {
    key: "gererValidationPersonaliseeInterne",
    value: function gererValidationPersonaliseeInterne(nomChamp, expression, fonction, retrait, champsAssocies, estAsync, champs) {
      var champ = champs.find(function (champ) {
        return champ.nom === nomChamp;
      });

      if (!(0, _utilitaires.estDefini)(champ)) {
        return;
      }

      var validations = champ.validations;

      if (!(0, _utilitaires.estDefini)(validations)) {
        validations = champ.validations = [];
      }

      var index = validations.findIndex(function (validation) {
        var expressionVal = validation.expression;
        var fonctionVal = validation.fonction;
        return (0, _utilitaires.estDefini)(expression) && (0, _utilitaires.estDefini)(expressionVal) && expressionVal.toString() === expression.toString() || (0, _utilitaires.estDefini)(fonction) && (0, _utilitaires.estDefini)(fonctionVal) && fonction === fonctionVal;
      });

      if (index != -1) {
        validations.splice(index, 1);
      }

      if (retrait !== true) {
        validations.push({
          expression: expression,
          fonction: fonction,
          champsAssocies: champsAssocies,
          estAsync: estAsync
        });
      }
    }
  }, {
    key: "declencherValidationParNom",
    value: function declencherValidationParNom(nomChamp) {
      var objetChamp = this.obtenirObjetChampParNom(nomChamp);

      if (!(0, _utilitaires.estDefini)(objetChamp, 'element')) {
        return;
      }

      (0, _utilitaires4.declencherEvennement)(objetChamp.element, 'blur');
    }
  }, {
    key: "gererValidationPersonalisee",
    value: function gererValidationPersonalisee(nomChamp, expression, fonction, retrait, champsAssocies, estAsync) {
      var champs = this.obtenirChampsFormulaire();
      this.gererValidationPersonaliseeInterne(nomChamp, expression, fonction, retrait, champsAssocies, estAsync, champs);
    }
  }, {
    key: "formaterSectionSiLieu",
    value: function formaterSectionSiLieu(section, nePasCloner) {
      var formaterSection = this.props.formaterSection;

      if (!(0, _utilitaires.estDefini)(formaterSection)) {
        return section;
      }

      return formaterSection(nePasCloner !== true ? (0, _utilitaires.cloner)(section) : section);
    }
  }, {
    key: "formaterSectionNavigationCommentaireSiLieu",
    value: function formaterSectionNavigationCommentaireSiLieu(section, index0) {
      if (!this.doitAfficherNavigationCommentaire()) {
        return this.formaterSectionSiLieu(section);
      }

      var nomCommentaireCible = this.state.nomCommentaireCible;

      if (!(0, _utilitaires.estDefini)(nomCommentaireCible)) {
        if (section.index === index0) {
          return this.formaterSectionNavigationCommentaire(section);
        } else {
          return this.formaterSectionSiLieu(section);
        }
      } else if (!(0, _utilitaires.estDefini)(section, ['champs', 'some'])) {
        return this.formaterSectionSiLieu(section);
      }

      return section.champs.some(function (champ) {
        return champ.nom === nomCommentaireCible;
      }) ? this.formaterSectionNavigationCommentaire(section, nomCommentaireCible) : this.formaterSectionSiLieu(section);
    }
  }, {
    key: "formaterSectionNavigationCommentaire",
    value: function formaterSectionNavigationCommentaire(section, nomChampCible) {
      var _this17 = this;

      if (!(0, _utilitaires.estDefini)(section, ['champs', 'length'])) {
        return this.formaterSectionSiLieu(section);
      }

      var nombreParColonne = (0, _utilitaires.estDefini)(section.nombreParColonne, 'map') ? section.nombreParColonne.map(function (n) {
        return n;
      }) : [];
      var champs = section.champs.map(function (champ) {
        return champ;
      });
      champs.sort(this.obtenirFonctionTri());
      var nouveauxChamps = champs.reduce(function (champs, champ, index) {
        if (champ.nom === nomChampCible || !(0, _utilitaires.estDefini)(nomChampCible) && index === 0) {
          var compte = 0;
          var rangee = null;
          nombreParColonne.some(function (valeur, indexStructure) {
            if (compte + valeur >= index + 1) {
              rangee = indexStructure;
              return true;
            }

            compte += valeur;
          });

          if ((0, _utilitaires.estDefini)(rangee)) {
            nombreParColonne.splice(rangee, 0, 1);
            champs.splice(index, 0, _this17.obtenirNavigationCommentaire(champ));
          }
        }

        champs.push((0, _utilitaires.cloner)(champ));
        return champs;
      }, []);
      var sectionClone = (0, _utilitaires.cloner)(section);
      sectionClone.champs = nouveauxChamps;
      sectionClone.nombreParColonne = nombreParColonne;
      return this.formaterSectionSiLieu(sectionClone, true);
    }
  }, {
    key: "obtenirLectureSeuleNavigationCommentaire",
    value: function obtenirLectureSeuleNavigationCommentaire() {
      var lectureSeuleCommentaire = this.props.lectureSeuleCommentaire;
      return lectureSeuleCommentaire === true ? true : this.state.lectureSeuleNavigationCommentaire;
    }
  }, {
    key: "obtenirNavigationCommentaire",
    value: function obtenirNavigationCommentaire(champ) {
      var _this$obtenirActionNa = this.obtenirActionNavigationCommentaire(),
          _this$obtenirActionNa2 = _slicedToArray(_this$obtenirActionNa, 2),
          action = _this$obtenirActionNa2[0],
          etiquetteAction = _this$obtenirActionNa2[1];

      return {
        nom: this.state.nomChampNavigationCommentaire,
        type: _MfaTypeChamp.MfaTypeChamp.navigationCommentaire,
        index: champ.index - 0.5,
        classeChamp: 'plein',
        surPrecedent: this.surNavigationCommentairePrecedent.bind(this),
        surSuivant: this.surNavigationCommentaireSuviant.bind(this),
        etiquette: this.obtenirEtiquetteNavigationCommentaires(),
        lectureSeule: this.obtenirLectureSeuleNavigationCommentaire(),
        etat: !this.aCommentaireNonCorrige() ? 'vert' : null,
        action: action,
        etiquetteAction: etiquetteAction
      };
    }
  }, {
    key: "doitEnvoyerCorrection",
    value: function doitEnvoyerCorrection() {
      return this.aCommentaireCorrigeSansStatut(this.statutCommentaire.Corrige) && !this.aCommentaireNonCorrige();
    }
  }, {
    key: "obtenirTexteCommentairesCorriges",
    value: function obtenirTexteCommentairesCorriges() {
      var etiquetteActionCommentairesCorriges = this.props.etiquetteActionCommentairesCorriges;
      return (0, _utilitaires.estDefini)(etiquetteActionCommentairesCorriges) ? etiquetteActionCommentairesCorriges : 'Envoyer';
    }
  }, {
    key: "obtenirActionNavigationCommentaire",
    value: function obtenirActionNavigationCommentaire() {
      var _this18 = this;

      var actionNull = [null, null];

      if (this.doitEnvoyerCorrection()) {
        return [this.envoieCorrectionCommentaire.bind(this), this.obtenirTexteCommentairesCorriges()];
      }

      var nomCommentaireCible = this.state.nomCommentaireCible;
      var commentaire = (0, _utilitaires.estDefini)(nomCommentaireCible) ? this.obtenirCommentaireParNom(nomCommentaireCible) : null;

      if ((0, _utilitaires.estDefini)(commentaire) && commentaire.statut < this.statutCommentaire.PretCorrection) {
        return actionNull;
      }

      var nom = this.obtenirNomCommentaireDirection(true, function (commentaire) {
        return commentaire.estCorrige === false;
      });
      var nomSuivant = this.obtenirNomCommentaireDirection(true);

      if ((0, _utilitaires.estDefini)(nom) && nom !== nomSuivant) {
        return [function () {
          return _this18.mettreAJourNavigationCommentaire(nom);
        }, 'Prochain non-corrigé'];
      }

      return actionNull;
    }
  }, {
    key: "envoieCorrectionCommentaire",
    value: function () {
      var _envoieCorrectionCommentaire = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this19 = this;

        var _this$props5, generateurAdresseEnvoieCorrectionCommenaitre, surEnvoieCorrectionCommentaire, doitEnvoyerCorrection, lectureSeuleNavigationCommentaire, commentaires, idsCommentairesCorriges, adresse;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this$props5 = this.props, generateurAdresseEnvoieCorrectionCommenaitre = _this$props5.generateurAdresseEnvoieCorrectionCommenaitre, surEnvoieCorrectionCommentaire = _this$props5.surEnvoieCorrectionCommentaire, doitEnvoyerCorrection = _this$props5.doitEnvoyerCorrection;

                if ((0, _utilitaires.estDefini)(generateurAdresseEnvoieCorrectionCommenaitre)) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return");

              case 3:
                lectureSeuleNavigationCommentaire = this.state.lectureSeuleNavigationCommentaire;

                if (!(lectureSeuleNavigationCommentaire === true)) {
                  _context10.next = 6;
                  break;
                }

                return _context10.abrupt("return");

              case 6:
                commentaires = this.obtenirCommentairesCorrigeable();
                idsCommentairesCorriges = commentaires.filter(function (commentaire) {
                  return commentaire.estCorrige === true && commentaire.statut === _this19.statutCommentaire.PretCorrection;
                }).map(function (commentaire) {
                  return commentaire.id;
                });

                if (!(idsCommentairesCorriges.length === 0)) {
                  _context10.next = 10;
                  break;
                }

                return _context10.abrupt("return");

              case 10:
                adresse = generateurAdresseEnvoieCorrectionCommenaitre(this.props.idLien);
                this.actionNavigationCommentaireLectureSeule( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                  var reponse, champs;
                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          reponse = false;
                          champs = _this19.obtenirChampsFormulaire();

                          if (!(doitEnvoyerCorrection !== false)) {
                            _context9.next = 9;
                            break;
                          }

                          _context9.next = 5;
                          return (0, _utilitaires2.requetePost)(adresse, _this19.context, idsCommentairesCorriges);

                        case 5:
                          _context9.next = 7;
                          return _context9.sent.json();

                        case 7:
                          reponse = _context9.sent;

                          if (reponse === true) {
                            _this19.obtenirCommentairesCorrigeable().forEach(function (commentaire) {
                              commentaire.desactive = true;
                              commentaire.statut = _this19.statutCommentaire.Corrige;
                              var champ = champs.find(function (champ) {
                                return champ.nom === commentaire.nomChamp;
                              });

                              if (!(0, _utilitaires.estDefini)(champ)) {
                                return;
                              }

                              champ.desactive = true;
                              champ.texteCorrection = 'En attente de révision';
                            });
                          }

                        case 9:
                          if ((0, _utilitaires.estDefini)(surEnvoieCorrectionCommentaire)) {
                            surEnvoieCorrectionCommentaire(reponse, champs);
                          }

                        case 10:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                })));

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function envoieCorrectionCommentaire() {
        return _envoieCorrectionCommentaire.apply(this, arguments);
      }

      return envoieCorrectionCommentaire;
    }()
  }, {
    key: "actionNavigationCommentaireLectureSeule",
    value: function () {
      var _actionNavigationCommentaireLectureSeule = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(action) {
        var _this20 = this;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.setState({
                  lectureSeuleNavigationCommentaire: true
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.next = 2;
                          return action();

                        case 2:
                          _this20.setState({
                            lectureSeuleNavigationCommentaire: false
                          });

                        case 3:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                })));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function actionNavigationCommentaireLectureSeule(_x8) {
        return _actionNavigationCommentaireLectureSeule.apply(this, arguments);
      }

      return actionNavigationCommentaireLectureSeule;
    }()
  }, {
    key: "obtenirEtiquetteNavigationCommentaires",
    value: function obtenirEtiquetteNavigationCommentaires() {
      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire)) {
        return null;
      }

      var commentaires = this.obtenirCommentairesCorrigeable();
      var nombreDeCommentaires;

      if (!(0, _utilitaires.estDefini)(commentaires) || (nombreDeCommentaires = commentaires.length) === 0) {
        return '';
      }

      var compte = commentaires.filter(function (commentaire) {
        return commentaire.estCorrige === true;
      }).length;
      return "".concat(compte, "/").concat(nombreDeCommentaires, " commentaires corrig\xE9s");
    }
  }, {
    key: "obtenirChampCourants",
    value: function obtenirChampCourants(pageCible, formulaire) {
      var sectionsCourantes = this.obtenirSectionsCourantes(pageCible, formulaire, true);

      if (!(0, _utilitaires.estDefini)(sectionsCourantes)) {
        return null;
      }

      return sectionsCourantes.prendrePlusieurs(function (section) {
        return section.champs;
      });
    }
  }, {
    key: "obtenirChampCourantsObligatoireVides",
    value: function obtenirChampCourantsObligatoireVides() {
      var _this21 = this;

      var champsCourants = this.obtenirChampCourants();

      if (!(0, _utilitaires.estDefini)(champsCourants)) {
        return null;
      }

      var valeurs = this.state.valeurs;
      return champsCourants.filter(function (champ) {
        return _this21.champEstConsidere(champ) && champ.estObligatoire && !(0, _utilitaires.nestPasNulOuVide)(valeurs[champ.nom]);
      });
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var _this22 = this;

      var formulaire = this.state.formulaire;

      if (!(0, _utilitaires.estDefini)(formulaire) || this.estEnChargment() !== false) {
        return null;
      }

      var _this$props6 = this.props,
          textePagePrecedente = _this$props6.textePagePrecedente,
          textePageSuivante = _this$props6.textePageSuivante,
          texteTermine = _this$props6.texteTermine,
          texteAnnulation = _this$props6.texteAnnulation,
          texteActionFin = _this$props6.texteActionFin;
      var numeroPageVisibleEtCacherPagesSuivantes = this.props.numeroPageVisibleEtCacherPagesSuivantes;
      var cacherAffichagePagesSuivantes = false;
      var pages = this.obtenirPagesFormulaire();
      var index = this.obtenirIndexPageCourante();
      var nombrePages = pages.length - 1;

      if ((0, _utilitaires.estDefini)(numeroPageVisibleEtCacherPagesSuivantes) && (0, _jquery.isNumeric)(numeroPageVisibleEtCacherPagesSuivantes)) {
        numeroPageVisibleEtCacherPagesSuivantes = numeroPageVisibleEtCacherPagesSuivantes - 1;

        if (nombrePages >= numeroPageVisibleEtCacherPagesSuivantes) {
          nombrePages = numeroPageVisibleEtCacherPagesSuivantes;
          cacherAffichagePagesSuivantes = index === numeroPageVisibleEtCacherPagesSuivantes;
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-formulaire-navigation"
      }, /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estSecondaire: true,
        onClick: function onClick() {
          return _this22.annulation();
        }
      }, (0, _utilitaires.estDefini)(texteAnnulation) ? texteAnnulation : "Annuler"), index > 0 ? /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estSecondaire: true,
        onClick: function onClick() {
          return _this22.pagePrecedente();
        }
      }, (0, _utilitaires.estDefini)(textePagePrecedente) ? textePagePrecedente : "Page ".concat(index)) : null, cacherAffichagePagesSuivantes ? null : index < nombrePages ? /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: function onClick() {
          return _this22.pageSuivante();
        }
      }, (0, _utilitaires.estDefini)(textePageSuivante) ? textePageSuivante : "Page ".concat(index + 2)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: function onClick() {
          return _this22.terminaison();
        }
      }, (0, _utilitaires.estDefini)(texteTermine) ? texteTermine : "Terminer"), /*#__PURE__*/_react.default.createElement(_MfaBouton.MfaBouton, {
        estPrincipal: true,
        onClick: function onClick() {
          return _this22.actionFin();
        }
      }, (0, _utilitaires.estDefini)(texteActionFin) ? texteActionFin : "Imprimer")));
    }
  }, {
    key: "changerPage",
    value: function changerPage(fcnIndex) {
      var index = this.obtenirIndexPageCourante();
      var indexCible = fcnIndex(index);
      this.changementDePage(indexCible);
    }
  }, {
    key: "pagePrecedente",
    value: function pagePrecedente() {
      this.changerPage(function (i) {
        return i - 1;
      });
    }
  }, {
    key: "pageSuivante",
    value: function pageSuivante() {
      this.changerPage(function (i) {
        return i + 1;
      });
    }
  }, {
    key: "obtenirChampsErronesCourants",
    value: function obtenirChampsErronesCourants() {
      var _this23 = this;

      var champsErrones = this.champsErrones;
      var nomsChampsErrones = Object.keys(champsErrones).filter(function (nom) {
        return (0, _utilitaires.estDefini)(champsErrones[nom]);
      });

      if (nomsChampsErrones.length === 0) {
        return [];
      }

      var champsCourants = this.obtenirChampCourants();

      if (!(0, _utilitaires.estDefini)(champsCourants) || champsCourants.length === 0) {
        return [];
      }

      return champsCourants.filter(function (champ) {
        return _this23.champEstConsidere(champ);
      }).map(function (champ) {
        return champ.nom;
      }).filter(function (nom) {
        return nomsChampsErrones.includes(nom);
      });
    }
  }, {
    key: "deroulerVersChamp",
    value: function deroulerVersChamp(nomChamp) {
      var objetChamp = this.obtenirObjetChampParNom(nomChamp);

      if (!(0, _utilitaires.estDefini)(objetChamp)) {
        return;
      }

      var champ = objetChamp.champ,
          element = objetChamp.element;
      var elementDeroulement = (0, _utilitaires.estDefini)(champ, 'enveloppe') ? champ.enveloppe : element;
      (0, _utilitaires4.deroulerVersTopElement)(elementDeroulement, 5, 1.05);
    }
  }, {
    key: "changementDePage",
    value: function changementDePage(index) {
      var _this24 = this;

      var pages = this.obtenirPagesFormulaire();
      var lectureSeule = this.obtenirLectureSeule(this.state.formulaire);

      if (!(0, _utilitaires.estDefini)(pages)) {
        return;
      }

      var surChangementDePage = this.props.surChangementDePage,
          champsErrones = this.champsErrones;
      pages.sort(function (a, b) {
        return a.index > b.index ? 1 : a.index < b.index ? -1 : 0;
      });
      var pageCourante = this.state.pageCourante;
      var pageCible = pages[index];

      if ((0, _utilitaires.estDefini)(pageCourante) && (0, _utilitaires.estDefini)(pageCible) && lectureSeule !== true) {
        var champsManquants = this.obtenirChampCourantsObligatoireVides();
        var champsCourantErrones = this.obtenirChampsErronesCourants();

        if (champsCourantErrones.length > 0) {
          this.deroulerVersChamp(champsCourantErrones[0]);
          return;
        } else if ((0, _utilitaires.estDefini)(champsManquants) && champsManquants.length > 0) {
          this.appliquerMessageErreur(champsManquants, this.messageObligatoire);
          this.deroulerVersChamp(champsManquants[0].nom);
          return;
        }
      }

      var nomCommentaireCible = this.obtenirNomPremierChampSiCommentaire(pageCible);
      this.setState({
        pageCourante: pageCible,
        nomCommentaireCible: nomCommentaireCible
      }, function () {
        if ((0, _utilitaires.estDefini)(surChangementDePage)) {
          surChangementDePage(pageCourante);
        }

        (0, _utilitaires4.deroulerVersTopElement)(_this24.entete, 5, 1.05, function () {
          return _this24.enregistrerPositionRelativeNaivgationCommentaireParElement(_this24.elementDeroulant);
        });
      });
    }
  }, {
    key: "renderEntetePersonalisee",
    value: function renderEntetePersonalisee() {
      var renderEntete = this.props.renderEntete,
          pageCourante = this.state.pageCourante;
      return (0, _utilitaires.estDefini)(renderEntete) ? renderEntete(pageCourante) : null;
    }
  }, {
    key: "renderEntete",
    value: function renderEntete(page) {
      var _this25 = this;

      var pageCourante = this.state.pageCourante,
          surUnePage = this.props.surUnePage;

      if (!(0, _utilitaires.estDefini)(page)) {
        page = pageCourante;
      }

      if (this.estEnChargment() === false) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "entete-page-".concat(page.id),
          className: "mfa-formulaire-entete",
          ref: function ref(_ref9) {
            return (0, _utilitaires.enregistrerSiDefini)(_this25, 'entete', _ref9);
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-ib"
        }, /*#__PURE__*/_react.default.createElement("h4", null, (0, _utilitaires.estDefini)(page) && (0, _utilitaires.estDefini)(page.titre) ? page.titre : '')), surUnePage !== true ? /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-ib mfa-ra"
        }, /*#__PURE__*/_react.default.createElement(_MfaFormulairePagination.MfaFormulairePagination, {
          numeroPageVisibleEtCacherPagesSuivantes: this.props.numeroPageVisibleEtCacherPagesSuivantes,
          surChangementDePage: function surChangementDePage(index) {
            return _this25.changementDePage(index - 1);
          },
          nombrePage: this.obtenirNombrePage(),
          pageActive: this.obtenirIndexPageCourante() + 1
        })) : null, /*#__PURE__*/_react.default.createElement(_MfaSeparateur.MfaSeparateur, null), this.renderEntetePersonalisee());
      }

      return null;
    }
  }, {
    key: "obtenirTexteConfirmationAnnulation",
    value: function obtenirTexteConfirmationAnnulation() {
      var texteConfirmationAnnulation = this.props.texteConfirmationAnnulation;

      if (!(0, _utilitaires.estDefini)(texteConfirmationAnnulation)) {
        return 'Voulez-vous annuler le formulaire?';
      }

      return texteConfirmationAnnulation;
    }
  }, {
    key: "obtenirTitreConfirmationAnnulation",
    value: function obtenirTitreConfirmationAnnulation() {
      var titreConfirmationAnnulation = this.props.titreConfirmationAnnulation;

      if (!(0, _utilitaires.estDefini)(titreConfirmationAnnulation)) {
        return 'Annuler';
      }

      return titreConfirmationAnnulation;
    }
  }, {
    key: "obtenirTexteBoutonConfirmationAnnulation",
    value: function obtenirTexteBoutonConfirmationAnnulation() {
      var textBoutonConfirmationAnnulation = this.props.textBoutonConfirmationAnnulation;

      if (!(0, _utilitaires.estDefini)(textBoutonConfirmationAnnulation)) {
        return 'Supprimer';
      }

      return textBoutonConfirmationAnnulation;
    }
  }, {
    key: "obtenirTexteBoutonAnnulationAnnulation",
    value: function obtenirTexteBoutonAnnulationAnnulation() {
      var textBoutonAnnulationAnnulation = this.props.textBoutonAnnulationAnnulation;

      if (!(0, _utilitaires.estDefini)(textBoutonAnnulationAnnulation)) {
        return 'Sauvgarder';
      }

      return textBoutonAnnulationAnnulation;
    }
  }, {
    key: "renderPage",
    value: function renderPage(page) {
      var _this26 = this;

      if (!(0, _utilitaires.estDefini)(page)) {
        return null;
      }

      return this.estEnChargment() === false ? /*#__PURE__*/_react.default.createElement(_MfaFormulairePage.MfaFormulairePage, {
        key: "page-".concat(page.id),
        index: page,
        ref: function ref(_ref10) {
          return (0, _utilitaires.enregistrerSiDefini)(_this26.pages, page.id, _ref10);
        },
        sections: this.obtenirSectionsCourantes(page)
      }) : null;
    }
  }, {
    key: "renderCorps",
    value: function renderCorps() {
      var _this27 = this;

      var _this$props7 = this.props,
          surUnePage = _this$props7.surUnePage,
          enChargement = _this$props7.enChargement;

      if (enChargement === true || this.state.enChargement === true) {
        return;
      }

      if (surUnePage !== true) {
        return this.renderPage(this.obtenirPage());
      } else {
        var sections = this.obtenirSections();
        return this.obtenirPagesFormulaire().filter(function (page) {
          return sections.some(function (section) {
            return section.idPage === page.id;
          });
        }).prendrePlusieurs(function (page) {
          return [_this27.renderEntete(page), _this27.renderPage(page)];
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this28 = this;

      var enChargement = this.state.enChargement,
          surUnePage = this.props.surUnePage;
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer.Dimmable, {
        className: "mfa-formulaire-enveloppe"
      }, surUnePage !== true ? this.renderEntete() : null, /*#__PURE__*/_react.default.createElement("form", {
        ref: function ref(_ref11) {
          return (0, _utilitaires.enregistrerSiDefini)(_this28, 'formulaire', _ref11);
        },
        className: "mfa-formulaire",
        target: "framecache",
        method: "post",
        action: "about:blank"
      }, this.renderCorps(), /*#__PURE__*/_react.default.createElement("iframe", {
        id: "framecache",
        name: "framecache",
        style: {
          display: 'none'
        },
        src: "about:blank"
      })), this.renderNavigation(), /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: this.state.afficherDialogueConfirmer,
        surAnnulation: function surAnnulation() {
          var surAnnulation = _this28.props.surAnnulation;

          if (!(0, _utilitaires.estDefini)(surAnnulation)) {
            return;
          }

          surAnnulation();
        },
        surSortie: function surSortie() {
          var surSortie = _this28.props.surSortie;

          if (!(0, _utilitaires.estDefini)(surSortie)) {
            return;
          }

          surSortie();
        },
        titre: this.obtenirTitreConfirmationAnnulation(),
        messageboutonAnnulation: this.obtenirTexteBoutonAnnulationAnnulation(),
        messageboutonSortie: this.obtenirTexteBoutonConfirmationAnnulation()
      }, this.obtenirTexteConfirmationAnnulation()), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer, {
        active: this.props.enChargement || enChargement,
        className: "mfa-formulaire-gradateur",
        inverted: true
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, null)));
    }
  }]);

  return MfaFormulaire;
}(_react.Component);

exports.MfaFormulaire = MfaFormulaire;

_defineProperty(MfaFormulaire, "contextType", _MfaContexte.MfaContexte);

_defineProperty(MfaFormulaire, "modifcationsParType", void 0);

_defineProperty(MfaFormulaire, "initialisationsParType", void 0);